import { Table, Empty } from 'antd';
import IArrow from '@imgs/icons/arrow-right.svg';

export default function ResetTable(props: any) {
  const itemRender = (current: number, type: any, originalElement: any) => {
    if (type === 'prev') {
      return (
        <span className='page-arrow-left'>
          <IArrow />
        </span>
      );
    }
    if (type === 'next') {
      return (
        <span className='page-arrow-right'>
          <IArrow />
        </span>
      );
    }
    return originalElement;
  };
  const { columns } = props;
  const validColumns = (columns || []).filter(Boolean);
  if (validColumns.length) {
    validColumns.forEach((item: any) => {
      if (!item.render) {
        const Obj = item;
        Obj.render = (text: any) =>
          text || <span className='empty-text'>-</span>;
      }
    });
  }

  const pagination = props.pagination
    ? {
        ...props.pagination,
        itemRender,
      }
    : props.pagination;

  return (
    <Table
      {...props}
      columns={validColumns}
      pagination={pagination}
      locale={{
        emptyText: props.emptyText || <Empty />,
      }}
    >
      {props?.children}
    </Table>
  );
}
